import { AbstractDialogContent } from '@abstracts/dialog/dialog-content';
import { Component, Injector, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ChargingStationsService } from '@services/entity/charging-stations.service';

@Component({
  selector: 'app-delete-group-dialog-content',
  templateUrl: './delete-group-dialog-content.component.html',
  styleUrls: ['./delete-group-dialog-content.component.scss']
})
export class DeleteGroupDialogContentComponent extends AbstractDialogContent implements OnInit {

  public className = 'DeleteGroupDialogContentComponent';

  @Input() private groupId: number;

  constructor(
    public activeModal: NgbActiveModal,
    private chargingStationsService: ChargingStationsService,
    injector: Injector) {
    super(activeModal, injector);
  }

  ngOnInit(): void {
    super.ngOnInit();
  }

  onConfirmClick() {
    this.chargingStationsService.deleteChargingStationGroup(this.groupId).subscribe(result => {
      this.activeModal.close({success: true});
    }, error => {

    });
  }
}
